// Slug → human-readable display name. Matches iOS IngredientMap.
const DISPLAY: Record<string, string> = {
  vitamin_c: 'Vitamin C',
  retinol: 'Retinol',
  retinoid: 'Retinoid',
  tretinoin: 'Tretinoin',
  niacinamide: 'Niacinamide',
  hyaluronic_acid: 'Hyaluronic Acid',
  ceramides: 'Ceramides',
  ceramide_moisturizer: 'Ceramide Moisturizer',
  peptides: 'Peptides',
  salicylic_acid: 'Salicylic Acid',
  azelaic_acid: 'Azelaic Acid',
  glycolic_acid: 'Glycolic Acid',
  lactic_acid: 'Lactic Acid',
  spf: 'Broad-Spectrum SPF',
  gentle_cleanser: 'Gentle Cleanser',
  centella: 'Centella Asiatica',
  bakuchiol: 'Bakuchiol',
  caffeine: 'Caffeine Eye Cream',
};

export function displayName(slug: string): string {
  return (
    DISPLAY[slug] ??
    slug
      .split('_')
      .map(s => s.charAt(0).toUpperCase() + s.slice(1))
      .join(' ')
  );
}
